export default __webpack_public_path__ + "static/media/office_window.d5877a1b.svg";